import { Button, Group } from '@mantine/core'
import { useForm, UseFormReturnType } from '@mantine/form'

import { FormValidateInput } from 'node_modules/@mantine/form/lib/types'
import { NavTag, PageHeader } from '../layout/pageHeader'
import { CancelButton } from './cancelButton'
import { Form } from './form'
import { Guard } from '../guard'

type Props<T> = {
  menu?: string
  action?: string
  code?: string
  title: string
  edit?: boolean
  initialValues: T
  validate: FormValidateInput<T> | undefined
  onSubmit?: (values: T) => Promise<void>
  formContent: (form: UseFormReturnType<T>) => React.ReactNode
}

export function CreateUpdateForm<T extends Record<string, unknown>>({
  menu,
  action,
  code,
  title,
  edit,
  initialValues,
  validate,
  onSubmit,
  formContent,
}: Props<T>) {
  const form = useForm<T>({
    mode: 'controlled',
    initialValues,
    validate,
  })
  const isSubmitting = form.submitting

  const handleSubmit = async (values: T) => {
    if (!onSubmit) return

    await onSubmit(values)
  }

  return (
    <>
      <PageHeader>
        <PageHeader.Title>
          <NavTag code={code || title} back={1}>
            {code ? title : ''}
          </NavTag>
          <NavTag sub>{edit ? 'แก้ไขรายการ' : 'สร้างรายการ'}</NavTag>
        </PageHeader.Title>
      </PageHeader>
      <Form form={form} onSubmit={handleSubmit}>
        {formContent(form)}
        <Group justify="flex-start" mt="md">
          {onSubmit && (
            <Guard menu={menu} action={action}>
              <Button
                type="submit"
                disabled={isSubmitting}
                loading={isSubmitting}
              >
                Submit
              </Button>
            </Guard>
          )}
          <CancelButton />
        </Group>
      </Form>
    </>
  )
}
